"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liZones = void 0;
var liZones = exports.liZones = [];